<div class="app-container">
    <avenir-top-header></avenir-top-header>
    @if (displayComponent && offlineEnabled) {
        <avenir-offline-global-banner></avenir-offline-global-banner>
    }
    @if(displayComponent) {
        <avenir-header [clientId]="clientId" testIdPrefix="app-header"></avenir-header>
    }
    <div class="content">
        <router-outlet></router-outlet>
    </div>
    @if(displayComponent) {
        <avenir-footer testIdPrefix="footer"></avenir-footer>
    }
</div>

<avenir-loader></avenir-loader>
<avenir-toast></avenir-toast>